export default __webpack_public_path__ + "static/media/Device-Upload-Sample.d8da96dd.xlsx";